// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"ac546500","391":"2591500a"}[chunkId] + ".chunk.js";
};